import forEach from 'lodash.foreach';
import MyAcvActiveBuying from '@/store/modules/auctions/MyAcv/myacv.active.buying.module';
import MyAcvActiveSelling from '@/store/modules/auctions/MyAcv/myacv.active.selling.module';
import MyAcvActivePendingProxy from '@/store/modules/auctions/MyAcv/myacv.active.pendingProxy.module';

const modules = {
  MyAcvActiveBuying,
  MyAcvActiveSelling,
  MyAcvActivePendingProxy,
};

const actions = {
  async getMyAcvAllActiveAuctions({
    dispatch,
  }) {
    try {
      const { persistentProxy } = this.state.featureFlags.featureFlagSlugs;
      const persistentProxyEnabled = await dispatch('getFlag', persistentProxy, { root: true });
      const activeBuyingAuctions = await dispatch('getMyAcvActiveBuyingAuctions');
      const activeSellingAuctions = await dispatch('getMyAcvActiveSellingAuctions');
      let pendingProxyAuctions = [];

      if (persistentProxyEnabled) {
        pendingProxyAuctions = await dispatch('getMyAcvPendingProxyAuctions');
      }

      const auctions = activeBuyingAuctions
        .concat(activeSellingAuctions.concat(pendingProxyAuctions));
      return auctions;
    } catch (error) {
      if (Array.isArray(error)) {
        throw error[0];
      }
      throw error instanceof Error ? error : new Error(error.message);
    } finally {
      // commit('setLoading', false);
    }
  },
  setQuery({
    dispatch,
    getters,
  }, query) {
    const submodules = Object.keys(modules);
    const root = { root: true };
    forEach(submodules, (moduleKey) => dispatch(
      'auctions/setQuery',
      {
        query,
        moduleKey: getters.submoduleKey(moduleKey),
      },
      root,
    ));
  },
  clearAuctions({
    dispatch,
    getters,
  }) {
    const submodules = Object.keys(modules);
    const root = { root: true };
    forEach(submodules, (moduleKey) => dispatch('auctions/clearAuctions', getters.submoduleKey(moduleKey), root));
  },
};

const getters = {
  submoduleKey: () => (submodule) => `MyAcvActive.${submodule}`,
};

export default {
  namespaced: true,
  modules,
  actions,
  getters,
};
